export class SimulationClock {
  /** seconds since start of the simulated service day (may exceed 86400) */
  time = 8 * 3600;
  speed = 1;
  paused = false;

  advance(realDtMs: number) {
    if (this.paused) return;
    this.time += (realDtMs / 1000) * this.speed;
  }

  get formatted(): string {
    const t = this.time;
    const day = Math.floor(t / 86400);
    const rest = t - day * 86400;
    const h = Math.floor(rest / 3600);
    const m = Math.floor((rest % 3600) / 60);
    const s = Math.floor(rest % 60);
    const hh = String(h + day * 24).padStart(2, '0');
    return `${hh}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }
}
